import NotificationCenter from "@app/components/Notifications/NotificationCenter";
import { Breadcrumb } from "@app/shared/components/Breadcrumb";
import { isNavbarOpenAtom } from "@app/store/navbarStore";
import { currentUserAtom } from "@app/store/userStore";
import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Button } from "@design-system/Inputs/Button";
import { Flex } from "@design-system/Layout/Flex";
import { useAtom, useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import TopBarHelp from "./TopBarHelp";
import TopBarProfil from "./TopBarProfil";
import "./i18n";
import "./index.css";

export default function TopBar() {
    const { data } = useAtomValue(currentUserAtom);
    const [isNavbarOpen, setIsNavbarOpen] = useAtom(isNavbarOpenAtom);
    const { t } = useTranslation("TopBar");

    const toggleSideBar = () => {
        setIsNavbarOpen(!isNavbarOpen);
    };

    return (
        <Flex
            w="full"
            justifyContent="between"
            alignItems="center"
            className="sticky top-0 bg-primary h-[64px] px-4 border-b border-tertiary __top-bar__"
        >
            <Flex className="flex-1">
                <Tooltip>
                    <Tooltip.Trigger asChild>
                        <Button
                            variant="text"
                            className="text-secondary"
                            onClick={toggleSideBar}
                        >
                            <Button.Icon name="panelLeft" />
                        </Button>
                    </Tooltip.Trigger>
                    <Tooltip.Content>{t("toggle_sidebar")}</Tooltip.Content>
                </Tooltip>
                <Breadcrumb />
            </Flex>
            <div className="flex justify-end items-center space-x-4 flex-1">
                <TopBarHelp />
                <NotificationCenter />
                <TopBarProfil currentUser={data?.currentUser} />
            </div>
        </Flex>
    );
}
